import { z } from 'zod'
import { CourtesyStatus, RewardCategory } from '~library/enums'
import { suitCommoditySchema } from './suit-commodity'
import { usedCourtesyNameSchema } from './used-courtesy-name'

export const benefitAndVoucherManagementRedeemBenefitsSchema = z.object({
  /** 使用禮遇項目 */
  usedCourtesy: z.array(
    usedCourtesyNameSchema.merge(
      z.object({
        /** 分類選項 */
        classType: z.nativeEnum(RewardCategory),
        /** 分類次選項 */
        classSecondType: z.string(),
        /** 分類第三選項 */
        classThirdType: z.string(),
        /** 狀態 */
        status: z.nativeEnum(CourtesyStatus),
        /** 券號 */
        couponNo: z.string(),
        /** EMD號碼 */
        emdNo: z.string(),
        /** 套裝商品 */
        suitCommodity: z.array(suitCommoditySchema)
      })
    )
  ),
  /** 行程資訊 */
  itineraryInformation: z.object({
    /** 訂位代號 */
    pnr: z.string(),
    /** 航空公司 */
    airline: z.string(),
    /** 機票號碼 */
    ticketNumber: z.string(),
    /** 開票日期 */
    issueTime: z.string(),
    /** 班機號碼 */
    flightNumber: z.string(),
    /** 航段 */
    flightSegment: z.array(z.string()),
    /** 出發日期 */
    departureTime: z.string(),
    /** 艙等 */
    rbd: z.string()
  })
})

export interface BenefitAndVoucherManagementRedeemBenefits
  extends z.infer<typeof benefitAndVoucherManagementRedeemBenefitsSchema> {}
export class BenefitAndVoucherManagementRedeemBenefits {
  constructor() {
    return {
      usedCourtesy: [
        {
          englishName: '',
          simplifiedName: '',
          traditionalName: '',
          classType: RewardCategory.APPR,
          classSecondType: '',
          classThirdType: '',
          status: CourtesyStatus.N,
          couponNo: '',
          emdNo: '',
          suitCommodity: []
        }
      ],
      itineraryInformation: {
        pnr: '',
        airline: '',
        flightNumber: '',
        ticketNumber: '',
        flightSegment: [],
        departureTime: '',
        issueTime: '',
        rbd: ''
      }
    }
  }
}
